import moment from 'moment';
import { useEffect, useState } from 'react';

export default function useInputTimeRange({ value, onChange, name, minTime }) {
  const [startTime, setStartTime] = useState(value[0]);
  const [endTime, setEndTime] = useState(value[1]);
  const [isError, setIsError] = useState(false);
  const [isErrorMin, setIsErrorMin] = useState(false);

  useEffect(() => {
    setStartTime(value[0]);
    setEndTime(value[1]);
  }, [value]);

  const handleChangeStart = (e) => {
    setStartTime(e.target.value);
    if (!moment(e.target.value, 'HH:mm').isBefore(moment(endTime, 'HH:mm'))) {
      const newEndtime = moment(e.target.value, 'HH:mm').add(1, 'hours').format('HH:mm');
      setEndTime(newEndtime);
      handleChange(e.target.value, newEndtime);
    } else {
      handleChange(e.target.value, endTime);
    }
  };

  const handleChangeEnd = (e) => {
    console.log(e.target.value);
    console.log(startTime);
    setEndTime(e.target.value);
    handleChange(startTime, e.target.value);
  };

  const handleChange = (start, end) => {
    if (validate(start, end)) {
      onChange({
        target: { name: name, value: [start, end] },
      });
    } else {
      onChange({
        target: { name: name, value: [], validity: { valid: false, badInput: true } },
      });
    }
  };

  const validate = (start, end) => {
    let startTime = moment(start, 'hh:mm');
    let endTime = moment(end, 'hh:mm');
    let validate = startTime.isBefore(endTime) && start.length === 5 && end.length === 5;

    if (validate && validateMin(start)) {
      setIsError(false);
      return true;
    }

    setIsError(true);
    return false;
  };

  const validateMin = (start) => {
    if (minTime) {
      const startTime = moment(start, 'hh:mm');
      const minTime = moment(minTime, 'hh:mm');
      const isValid = startTime.isSameOrAfter(minTime);
      setIsErrorMin(!isValid);
      return isValid;
    }

    return true;
  };

  return { startTime, endTime, isError, isErrorMin, handleChangeStart, handleChangeEnd };
}
